/* eslint-disable max-len */
import React, { useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

import { Icon } from '@codex-brightworld/icons';
import YouTubeVideo from './YTVideo';
import { productSizingVideo } from '../../../analytics';

const PackagingVideoSection = styled.div`
    width: 44%;
    @media ${(props) => props.theme.breakpoints.mobile} {
      width: auto;
      padding: 10px;
      margin-left: 15px;
    }
    @media ${(props) => props.theme.breakpoints.tablet} {
        width: 50%;
    }
    padding: 18px;
    margin: auto;
    box-sizing: border-box;
    border-radius: 8px;
    border: solid 1px ${(props) => props.theme.colors.neutral.grey[2]};
    font-family: ${(props) => props.theme.fonts.default.fontFamily};
 `;
const PackagingVideoSectionTitle = styled.div`
    padding-bottom: 10px;
    font-weight: bold;
    font-size: 14px;
 `;
const PackagingVideoSectionTitleText = styled.span`
    padding-left: 10px;
`;
const PackagingVideoSectionDescription = styled.div`
    padding-bottom: 18px;
    line-height: 1.4em;
 `;
const PackagingAlternativeVideoSectionText = styled.div`
  a {
    text-decoration: none;
    line-height: 1.4em;
    color: ${(props) => props.theme.colors.primary.purple};
  }
`;
const VideoContainer = styled.div`
    position: relative;
    padding-bottom: 56.25%;
    border: solid 1px ${(props) => props.theme.colors.neutral.grey[2]};
`;

const AlternativeVideo = styled.iframe`
  border: none;
  position: absolute;
  width: 0;
  height: 0;
  max-width: 100%;
  min-width: 100%;
  max-height: 100%;
  min-height: 100%;  
`;

const AlertIcon = styled(Icon)`
    width: 22px;
    height: 17px;
    margin: -3px 1px 4px;
    stroke: none;
`;

const VideoSection = ({ translations, imageBasePath, isAlternative }) => {
  const title = translations['component.packaging.videoSectionTitle'];
  const description = translations['component.packaging.videoSectionDescription'];
  // eslint-disable-next-line react/prop-types
  const alternativeDescription = translations['component.packaging.alternativeVideoSectionText'];
  const videoUrl = translations['component.packaging.videoSectionUrl'];
  const videoId = videoUrl.replace('https://www.youtube.com/embed/', '');

  useEffect(() => {
    const checkIframeClick = setInterval(() => {
      const elem = document.activeElement;
      const covidVideo = document.querySelector("[title^='COVID-19']");
      let alreadyExists = false;

      if (window.digitalData && window.digitalData.events.length > 0) {
        (window.digitalData.events).map((dD) => {
          if (dD.data.pdpSizingEngagamentType === 'play Covid19 video') {
            alreadyExists = true;
          }
          return null;
        });
      }

      if (elem && elem === covidVideo && !alreadyExists) {
        productSizingVideo('play Covid19 video');
        clearInterval(checkIframeClick);
      }
    }, 100);
  });

  return (
    <PackagingVideoSection>
      <PackagingVideoSectionTitle>
        {isAlternative
          ? (
            <>
              <AlertIcon icon="alert" />
              <PackagingVideoSectionTitleText>{title}</PackagingVideoSectionTitleText>
            </>
          )
          : <>{title}</>}
      </PackagingVideoSectionTitle>
      <PackagingVideoSectionDescription dangerouslySetInnerHTML={{ __html: description }} />
      {isAlternative
        ? (
          <>
            <VideoContainer>
              <AlternativeVideo
                title={title}
                src={videoUrl}
                frameBorder={'0'}
                allow={'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'}
                allowFullScreen
                scrolling={'no'}
              />
            </VideoContainer>
            <EnvironmentThemeProvider>
              <PackagingAlternativeVideoSectionText dangerouslySetInnerHTML={{ __html: alternativeDescription }} />
            </EnvironmentThemeProvider>
          </>
        )
        : (
          <>
            <VideoContainer>
              <YouTubeVideo
                id={videoId}
                title={title}
              />
            </VideoContainer>
          </>
        )}
    </PackagingVideoSection>
  );
};

VideoSection.propTypes = {
  imageBasePath: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    'component.packaging.videoSectionTitle': PropTypes.string.isRequired,
    'component.packaging.videoSectionDescription': PropTypes.string.isRequired,
    'component.packaging.videoSectionUrl': PropTypes.string.isRequired,
    'component.packaging.downloadAppDescription': PropTypes.string,
    'component.packaging.appStoreUrl': PropTypes.string,
    'component.packaging.playStoreUrl': PropTypes.string
  }).isRequired,
  isAlternative: PropTypes.bool.isRequired
};
export default VideoSection;
